export enum USER_ROLES {
	ADMIN = "ADMIN",
	COLLABORATOR = "COLLABORATOR",
	VIEWER = "VIEWER",
	ACCOUNTANT = "ACCOUNTANT",
	OWNER = "OWNER",
}
